import { useTranslation } from 'react-i18next';

import { type TDisplayColumnData } from 'components/data/types';
import { Button, Modal, ModalActionButtons } from 'components/ui';
import { type AtlasGqlTableView } from 'types/atlas-graphql';

import { Summary } from '../Summary';
import { StyledCollapse } from '../Views.style';

const { Panel } = StyledCollapse;

export type ConditionsState = {
  isOpen: boolean;
  tableView?: Partial<AtlasGqlTableView>;
  columnDefs?: TDisplayColumnData[];
};

type ConditionsModalProps = {
  conditionsState: ConditionsState;
  onClose: () => void;
};

export const ConditionsModal: React.FunctionComponent<ConditionsModalProps> = ({
  conditionsState,
  onClose,
}) => {
  const { t } = useTranslation();
  const { isOpen, tableView, columnDefs } = conditionsState;

  return (
    <Modal
      open={isOpen && !!tableView}
      title={t('table.conditions', 'Conditions')}
      onCancel={onClose}
      destroyOnClose
      footer={null}
    >
      <StyledCollapse defaultActiveKey={['table_conditions']}>
        <Panel
          key={'table_conditions'}
          header={t('components.tableConditions', 'Table Conditions')}
        >
          {tableView && columnDefs && <Summary tableView={tableView} columnDefs={columnDefs} />}
        </Panel>
      </StyledCollapse>
      <ModalActionButtons>
        <Button type="primary" onClick={onClose}>
          {t('common.close', 'Close')}
        </Button>
      </ModalActionButtons>
    </Modal>
  );
};
